module.exports = __webpack_public_path__ + "img/long-right.30668280.svg";